/**
 * A single flag that holds the tutor's resume turn until the client has
 * finished restoring the bite.
 *
 * The backend starts that turn as soon as it has restored the slide server
 * side, which can be before this browser has re-revealed fragments, inputs and
 * the notepad. Playing it then would narrate content the student cannot see.
 *
 * It is a module-level ref rather than state because `usePlayerTick` reads it
 * inside a requestAnimationFrame callback, and because the two queues that must
 * observe it are mounted in different subtrees from the code that sets it.
 *
 * Suspending the audio context alone is NOT enough: a muted turn streams no
 * audio at all (the backend swaps in MockTTSService, which emits timings and
 * nothing else), so there is no audio clock to freeze and the action queue
 * would run on regardless. This flag is what covers that case.
 */
export const resumePlaybackHoldRef = { current: false };

export const holdResumePlayback = (): void => {
  resumePlaybackHoldRef.current = true;
};

export const releaseResumePlayback = (): void => {
  resumePlaybackHoldRef.current = false;
};

export const isResumePlaybackHeld = (): boolean =>
  resumePlaybackHoldRef.current;
